import { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { APIs } from '../config/apis';
import { BACKEND_CONFIG } from '../config/backend';

export const useApiStatus = () => {
  const [apiStatus, setApiStatus] = useState({});
  const [statusLoading, setStatusLoading] = useState(false); // ✅ CORRIGIDO!

  const checkApiStatus = async () => {
    setStatusLoading(true);
    try {
      const statusPromises = Object.entries(APIs).map(async ([apiKey, api]) => {
        try {
          // Usar proxy do backend para evitar Mixed Content
          let proxyUrl;
          
          if (apiKey === 'apiBancoBitrix') {
            // Para API Bitrix, usar endpoint específico
            proxyUrl = `${BACKEND_CONFIG.BASE_URL}/api/proxy/bitrix/status`;
          } else {
            // Para outras APIs, mapear para endpoints do proxy
            const proxyMap = {
              'apiRegistroInteresse': 'registro-interesse',
              'apiBitrixComentarios': 'comentarios',
              'apiBitrixComentarioNovo': 'comentarios',
              'apiRegistroConversa': 'conversas'
            };
            
            const proxyEndpoint = proxyMap[apiKey];
            if (proxyEndpoint) {
              proxyUrl = `${BACKEND_CONFIG.BASE_URL}/api/proxy/external/${proxyEndpoint}/status`;
            } else {
              // Fallback para APIs não mapeadas
              proxyUrl = `${BACKEND_CONFIG.BASE_URL}/api/proxy/health`;
            }
          }
          
          const response = await axios.get(proxyUrl, { timeout: 5000 });
          
          return {
            name: apiKey,
            status: 'online',
            response: response.data,
            timestamp: new Date().toISOString(),
            source: 'proxy'
          };
        } catch (error) {
          console.warn(`API ${apiKey} indisponível:`, error.message);
          return {
            name: apiKey,
            status: 'offline',
            error: error.message,
            timestamp: new Date().toISOString(),
            source: 'proxy',
            message: 'API temporariamente indisponível'
          };
        }
      });
      
      const statusResults = await Promise.all(statusPromises);
      const statusData = {};
      statusResults.forEach(api => {
        statusData[api.name] = api;
      });
      setApiStatus(statusData);
      
      // Mostrar toast apenas se houver APIs online
      const onlineApis = statusResults.filter(api => api.status === 'online');
      if (onlineApis.length > 0) {
        toast.success(`${onlineApis.length} API(s) online!`);
      } else {
        toast.warning('Algumas APIs estão temporariamente indisponíveis');
      }
    } catch (error) {
      toast.error('Erro ao verificar status das APIs');
      console.error('Erro ao verificar status:', error);
    } finally {
      setStatusLoading(false);
    }
  };

  useEffect(() => {
    checkApiStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    apiStatus,
    statusLoading,
    checkApiStatus
  };
};
